app.isThinking = false

app.loader = {
  $el: $('.loading-bar__activity'),
  loop: function () {
    this.$el.css('left', '-100%').show()
    this.$el.animate({ left: '100%' }, 1000, () => this.loop())
  },
  stop: function () {
    this.$el.stop().hide()
  },
  start: function () {
    this.stop()
    this.loop()
  }
}

app.completeReload = function () {
  if (app.thinkingTimer) {
    clearTimeout(app.thinkingTimer)
    app.thinkingTimer = null
  }
  app.isThinking = false
  app.loader.stop()
}

const state = {}
app.state = function (name, value) {
  if (value === undefined) {
    return name === value ? state : state[name]
  }
  state[name] = value
}
